import React, { useMemo } from 'react';
import cn from '@/utils/cn';
import SPADataTable from '../../shared/SPADataTable';
import { tintStyle } from '../../shared/tint';
import getLessonColumns from './lessonColumns';
import { ProgramLesson, ProgramUnit } from './types';
import UnitActionsMenu from './UnitActionsMenu';
import { savedFlashRowClass, useLessonSavedFlash } from './lessonSavedFlash';
import { useReorderLessons } from './useProgramLessons';

export const lessonRowId = (lesson: ProgramLesson) => lesson.id;
export const lessonRowLabel = (lesson: ProgramLesson) => lesson.title;

interface UnitLessonGroupProps {
  lessons: ProgramLesson[];
  programId: number;
  unit: ProgramUnit;
}

const headerClass = cn(
  'tw-px-4 tw-py-5 tw-rounded-t-md',
  'tw-text-spa-on-bg tw-text-base tw-font-semibold',
  'tw-border tw-border-solid tw-border-spa-border tw-border-b-0',
  'tw-flex tw-items-center tw-justify-between',
);

const UnitLessonGroup = ({ lessons, programId, unit }: UnitLessonGroupProps) => {
  const columns = useMemo(() => getLessonColumns(programId), [programId]);
  const reorderLessons = useReorderLessons(programId);
  const { flashedLessonId } = useLessonSavedFlash();

  return (
    <div className="tw-mb-6">
      <div className={headerClass} style={tintStyle(unit.color)}>
        {unit.title_with_position}
        <UnitActionsMenu programId={programId} unit={unit} />
      </div>
      <SPADataTable
        columns={columns}
        data={lessons}
        defaultSort={[]}
        emptyMessage="No lessons in this unit."
        reorder={{ getRowId: lessonRowId, getRowLabel: lessonRowLabel, onReorder: reorderLessons }}
        rowClassName={savedFlashRowClass(flashedLessonId)}
      />
    </div>
  );
};

export default UnitLessonGroup;
